<div class="p-4">
    <h1 class="mb-8">Event</h1>
    @if (!loading){
        <div class="px-8 py-2">
            <app-event-overview-panel [event]="overview" [readonly]="true"></app-event-overview-panel>
        </div>
        

        <p-tabs [(value)]="activeTab" scrollable class="mt-8">
            <p-tablist>
                <p-tab value="overview"><i class="pi pi-home mr-2"></i><span>Overview</span></p-tab>
                <p-tab value="details"><i class="pi pi-list mr-2"></i><span>Full Details</span></p-tab>
                <p-tab value="actions"><i class="pi pi-play mr-2"></i><span>Actions</span></p-tab>
                <p-tab value="comments"><i class="pi pi-comments mr-2"></i><span>Comments</span></p-tab>
                <p-tab value="attachments"><i class="pi pi-paperclip mr-2"></i><span>Attachments</span></p-tab>
                <p-tab value="workflows"><i class="pi pi-share-alt mr-2"></i><span>Workflows</span></p-tab>
                <p-tab value="history"><i class="pi pi-history mr-2"></i><span>History</span></p-tab>
            </p-tablist>
            <p-tabpanels>
                <p-tabpanel value="overview">
                    <div class="grid grid-cols-1 lg:grid-cols-4 gap-4">
                      <div class="p-4 rounded-lg border border-grey-200 bg-white shadow-sm">
                        <p class="text-xs uppercase tracking-wide text-grey-600 mb-1">Event</p>
                        <p class="text-lg font-semibold">{{overview.SummaryQuestion || 'Event'}}</p>
                        <p class="text-sm text-grey-700">{{overview.LocationName}}</p>
                        <p class="text-xs text-grey-600 mt-1">Created {{overview.DateCreated | date:'mediumDate'}} by {{overview.UserCreated}}</p>
                      </div>
                      <div class="p-4 rounded-lg border border-grey-200 bg-white shadow-sm">
                        <p class="text-xs uppercase tracking-wide text-grey-600 mb-1">Status</p>
                        <div class="flex items-center gap-2 mb-2">
                          <span class="px-2 py-1 rounded-full text-xs font-semibold bg-green-50 text-green-800 border border-green-200">{{overview.EventStatus || 'Unknown'}}</span>
                          @if (savingStatus) {
                            <i class="pi pi-spin pi-spinner text-green-700"></i>
                          }
                        </div>
                        <div class="flex items-center gap-2">
                          <select class="text-box flex-1" [(ngModel)]="selectedStatusId" [disabled]="loadingStatuses || savingStatus">
                            <option [ngValue]="null" disabled>Please Select...</option>
                            @for (status of eventStatuses; track status.EventStatusID) {
                              <option [ngValue]="status.EventStatusID">{{status.EventStatusDescription}}</option>
                            }
                          </select>
                          <button type="button" class="btn-primary" (click)="saveEventStatus()" [disabled]="savingStatus || loadingStatuses">
                            {{savingStatus ? 'Saving...' : 'Update'}}
                          </button>
                        </div>
                        @if (statusError) {
                          <p class="text-xs text-danger-base mt-2">{{statusError}}</p>
                        }
                        @if (loadingStatuses) {
                          <p class="text-xs text-grey-600 mt-2">Loading statuses...</p>
                        }
                      </div>
                      <div class="p-4 rounded-lg border border-grey-200 bg-white shadow-sm">
                        <p class="text-xs uppercase tracking-wide text-grey-600 mb-1">Actions</p>
                        <div class="flex gap-4">
                          <div>
                            <p class="text-2xl font-semibold">{{openActions.length}}</p>
                            <p class="text-xs text-grey-700">Open</p>
                          </div>
                          <div>
                            <p class="text-2xl font-semibold">{{resolvedActions.length}}</p>
                            <p class="text-xs text-grey-700">Resolved</p>
                          </div>
                          <div>
                            <p class="text-2xl font-semibold text-danger-base">{{overdueCount}}</p>
                            <p class="text-xs text-grey-700">Overdue</p>
                          </div>
                          <div>
                            <p class="text-2xl font-semibold text-warning-strong">{{dueTodayCount}}</p>
                            <p class="text-xs text-grey-700">Due today</p>
                          </div>
                        </div>
                      </div>
                      <div class="p-4 rounded-lg border border-grey-200 bg-white shadow-sm">
                        <p class="text-xs uppercase tracking-wide text-grey-600 mb-1">Required {{ 'audit' | customerTerm:true }}</p>
                        @if (pendingAuditActions.length === 0) {
                          <p class="text-sm text-grey-700">No linked actions pending.</p>
                        }
                        @if (pendingAuditActions.length > 0) {
                          <p class="text-sm text-grey-700 mb-2">{{ ('Linked audit required for ' + pendingAuditActions.length + (pendingAuditActions.length === 1 ? ' action.' : ' actions.')) | customerText }}</p>
                          <div class="flex flex-col gap-2">
                            @for (a of pendingAuditActions; track a.ActionID) {
                              <div class="border border-grey-100 rounded p-2 bg-grey-50">
                                <p class="font-semibold text-sm">{{a.ActionDescription}}</p>
                                <p class="text-xs text-grey-700">{{ 'audit' | customerTerm }}: {{a.AuditName || ('audit' | customerTerm)}} · Assigned to {{a.AssignedTo || 'Unassigned'}}</p>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>

                    <div class="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
                      <div class="p-4 rounded-lg border border-grey-200 bg-white shadow-sm">
                        <h3 class="text-lg font-semibold mb-3">Upcoming actions</h3>
                        @if (topDueActions.length === 0) {
                          <p class="text-sm text-grey-700">No upcoming actions.</p>
                        }
                        @for (a of topDueActions; track a.ActionID) {
                          <div class="border border-grey-100 rounded p-2 mb-2">
                            <p class="font-semibold">{{a.ActionDescription}}</p>
                            <p class="text-xs text-grey-700">Due {{a.ActionDeadline | date:'mediumDate'}} · {{a.AssignedTo}}</p>
                          </div>
                        }
                      </div>
                      <div class="p-4 rounded-lg border border-grey-200 bg-white shadow-sm">
                        <h3 class="text-lg font-semibold mb-3">Recent comments</h3>
                        @if ((comments || []).length === 0) {
                          <p class="text-sm text-grey-700">No comments yet.</p>
                        }
                        @if ((comments || []).length > 0) {
                          @for (c of (comments | slice:0:3); track c.EventCommentID) {
                            <div class="border border-grey-100 rounded p-2 mb-2">
                              <p class="text-sm text-grey-900">{{c.Comment}}</p>
                              <p class="text-xs text-grey-600 mt-1">{{c.UserDisplayName || 'User'}} · {{c.DateCreated | date:'mediumDate'}}</p>
                            </div>
                          }
                        }
                      </div>
                    </div>
                </p-tabpanel>
                <p-tabpanel value="details">
                    <app-audit-result-detail [auditResultDetail]="details" [eventId]="EventID" [showQuestionsAccordion]="true"></app-audit-result-detail>
                    @if (loadingAdditionalAudits) {
                      <p class="p-4 text-sm text-grey-700">Loading additional audits...</p>
                    }
                    @if (!loadingAdditionalAudits && additionalAuditResults.length > 0) {
                      <div class="mt-4 flex flex-col gap-4">
                        <h3 class="text-lg font-semibold">Other event information</h3>
                        @for (audit of additionalAuditResults; track audit.AuditResultID) {
                          <app-audit-result-detail [auditResultDetail]="audit" [eventId]="EventID" [showQuestionsAccordion]="true"></app-audit-result-detail>
                        }
                      </div>
                    }
                </p-tabpanel>
                <p-tabpanel value="actions">
                    <div class="flex flex-col lg:flex-row gap-4">
                        <div class="lg:w-1/2 w-full">
                            <app-event-actions-list
                                [actions]="outstandingActions"
                                [loading]="loadingActions"
                                (viewAction)="openActionDetail($event)"
                            ></app-event-actions-list>
                        </div>
                        <div class="lg:w-1/2 w-full">
                            @if (loadingActionUsers) {
                                <p class="p-4">Loading users...</p>
                            }
                            @if (!loadingActionUsers) {
                                <app-event-action-add
                                    [eventId]="EventID"
                                    [locationId]="overview.CustomerLocationID"
                                    [users]="actionUsers"
                                    [saving]="savingAction"
                                    [auditOptions]="actionAuditOptions"
                                    [auditsLoading]="loadingActionAudits"
                                    [resetToken]="newActionResetToken"
                                    (saveAction)="onSaveEventAction($event)"
                                ></app-event-action-add>
                            }
                        </div>
                    </div>
                </p-tabpanel>
                <p-tabpanel value="comments">
                    <app-event-comments
                      [comments]="comments"
                      [saving]="savingComment"
                      [loading]="loadingComments"
                      [errorMessage]="commentError"
                      (addComment)="addComment($event)">
                    </app-event-comments>
                </p-tabpanel>
                <p-tabpanel value="attachments">
                    <app-event-attachments
                      [attachments]="eventAttachments"
                      [uploading]="uploadingEventAttachment"
                      [errorMessage]="eventAttachmentError"
                      (uploadFile)="onUploadEventAttachment($event)"
                      (downloadFile)="onDownloadEventAttachment($event)"
                      (removeFile)="onRemoveEventAttachment($event)">
                    </app-event-attachments>
                    <p-confirmpopup key="eventAttachmentConfirm" styleClass="confirm-popup-danger">
                      <ng-template pTemplate="headless" let-confirmation>
                        <div class="confirm-popup-wrapper flex items-start gap-3">
                          <i class="pi pi-exclamation-triangle text-danger-base text-xl"></i>
                          <div class="flex flex-col gap-3 w-full">
                            <div>
                              <p class="font-semibold text-sm">{{confirmation?.header || 'Remove attachment'}}</p>
                              <p class="text-sm text-grey-700">{{confirmation?.message || 'Are you sure you want to remove this attachment?'}}</p>
                            </div>
                            <div class="flex gap-2 justify-end w-full">
                              <button pButton type="button" class="btn-inverse btn-compact btn-xs confirm-keep-btn" (click)="onConfirmReject(confirmation)">
                                <i class="pi pi-undo mr-1"></i>
                                <span>Keep</span>
                              </button>
                              <button pButton type="button" class="btn-negative btn-compact btn-xs confirm-remove-btn" (click)="onConfirmAccept(confirmation)">
                                <i class="pi pi-trash mr-1"></i>
                                <span>Remove</span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </p-confirmpopup>
                </p-tabpanel>
                <p-tabpanel value="workflows">
                    <div class="flex flex-col gap-3">
                        @if (loadingWorkflows) {
                            <p>Loading workflows...</p>
                        }
                        @if (!loadingWorkflows && workflowError) {
                            <p class="text-danger-base text-sm">{{workflowError}}</p>
                        }
                        @if (!loadingWorkflows) {
                            <div class="grid grid-cols-1 md:grid-cols-2 gap-3 mb-3">
                                @for (wf of workflows; track wf.WorkflowID) {
                                    <div class="workflow-card border border-grey-200 rounded p-3 cursor-pointer"
                                         [class.selected-card]="wf.WorkflowID === selectedWorkflowId"
                                         [class.disabled-card]="wf.ActionCount === 0"
                                         (click)="wf.ActionCount > 0 && selectWorkflow(wf.WorkflowID)">
                                        <div class="flex items-start justify-between gap-2">
                                            <div>
                                                <p class="font-semibold text-base">{{wf.Name}}</p>
                                                @if (wf.Description) {
                                                    <p class="text-sm text-grey-700">{{wf.Description}}</p>
                                                }
                                            </div>
                                            <div class="text-xs text-grey-700">Actions: {{wf.ActionCount}}</div>
                                        </div>
                                    </div>
                                }
                            </div>
                            @if (loadingWorkflowActions) {
                                <p>Loading actions...</p>
                            }
                            @if (!loadingWorkflowActions && selectedWorkflowId === -1) {
                                <p>Select a workflow to view actions.</p>
                            }
                            @if (!loadingWorkflowActions && workflowActions.length > 0) {
                                @if (selectedWorkflowInfo) {
                                    <div class="mb-2">
                                        <p class="font-semibold text-lg">{{selectedWorkflowInfo.Name}}</p>
                                        @if (selectedWorkflowInfo.Description) {
                                            <p class="text-sm text-grey-700">{{selectedWorkflowInfo.Description}}</p>
                                        }
                                    </div>
                                }
                                <div class="overflow-x-auto">
                                    <table class="min-w-full text-sm">
                                        <thead>
                                            <tr class="text-left border-b">
                                                <th class="px-2 py-2">Include</th>
                                                <th class="px-2 py-2">Title</th>
                                                <th class="px-2 py-2">Mandatory</th>
                                                <th class="px-2 py-2">Due (days)</th>
                                                <th class="px-2 py-2">Owner</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            @for (act of workflowActions; track act.WorkflowActionID) {
                                                <tr class="border-b">
                                                    <td class="px-2 py-2">
                                                        <input type="checkbox"
                                                          [disabled]="act.IsMandatory"
                                                          [(ngModel)]="workflowSelections[act.WorkflowActionID].Include"
                                                          (ngModelChange)="toggleActionSelection(act.WorkflowActionID, $event)">
                                                    </td>
                                                    <td class="px-2 py-2">
                                                        <div class="font-semibold">{{act.Title}}</div>
                                                        @if (act.Description) {
                                                            <div class="text-xs text-grey-700">{{act.Description}}</div>
                                                        }
                                                    </td>
                                                    <td class="px-2 py-2">
                                                        @if (act.IsMandatory) {
                                                            <span class="text-xs text-danger-base font-semibold">Mandatory</span>
                                                        }
                                                    </td>
                                                    <td class="px-2 py-2">
                                                        <input type="number" min="0" class="text-box w-24" [(ngModel)]="workflowSelections[act.WorkflowActionID].DueInDays" (ngModelChange)="updateActionDue(act.WorkflowActionID, $event)">
                                                    </td>
                                                    <td class="px-2 py-2">
                                                        <select class="text-box" [(ngModel)]="workflowSelections[act.WorkflowActionID].OwnerUserID" (ngModelChange)="updateActionOwner(act.WorkflowActionID, $event, ownerTypeFor($event))">
                                                            <option [ngValue]="null">Please Select...</option>
                                                            @for (user of actionUsers; track user.UserID) {
                                                                <option [ngValue]="user.UserID">{{user.DisplayName}}</option>
                                                            }
                                                        </select>
                                                    </td>
                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                                <div class="flex justify-end mt-3">
                                    <button class="btn-primary" type="button" (click)="applySelectedWorkflow()" [disabled]="applyingWorkflow || loadingWorkflowActions">
                                        <i class="pi" [ngClass]="applyingWorkflow ? 'pi-spin pi-spinner' : 'pi-check'"></i>
                                        <span class="ml-1">{{applyingWorkflow ? 'Applying...' : 'Apply workflow'}}</span>
                                    </button>
                                </div>
                            }
                        }
                    </div>
                </p-tabpanel>
                <p-tabpanel value="history">
                    @if (eventHistoryError) {
                      <p class="text-danger-base text-sm mb-2">{{eventHistoryError}}</p>
                    }
                    @if (loadingEventHistory) {
                      <p>Loading history...</p>
                    }
                    @if (!loadingEventHistory) {
                      <app-event-history-timeline [history]="eventHistory"></app-event-history-timeline>
                    }
                </p-tabpanel>
            </p-tabpanels>
        </p-tabs>



        
    }
</div>

